import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { TERMS, TERMS_UPDATED } from "@/lib/terms";

export default function TermsPage() {
  const { lang, t, terms } = useLang();
  const nav = useNavigate();
  const T = terms;
  return (
    <div className="screen" data-testid="terms-screen">
      <header className="sites-header">
        <div><div className="header-title">{T.title}</div><div className="header-sub">{t("Last updated")}: {(TERMS_UPDATED[lang] || TERMS_UPDATED.en)}</div></div>
        <button type="button" className="header-btn" data-testid="terms-close" aria-label={t("Close")}
          onClick={() => (window.history.state?.idx > 0 ? nav(-1) : nav("/"))}><X size={20} /></button>
      </header>
      <div className="screen-body terms-body">
        {T.sections.map(([h, p], i) => (
          <section key={h} data-testid={`terms-section-${i}`}>
            <h3 className="terms-h">{i + 1}. {h}</h3>
            <p className="terms-p">{p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
